module.exports = __webpack_public_path__ + "static/img/yy.6189fef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/audit/yy.png
// module id = vhNp
// module chunks = 1